export const assets = import.meta.glob<true, string, string>("./**/*.(svg|png|jpg|jpeg|webp)", {
  eager: true,
  import: "default",
});
